import React, { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import GoogleSignInButton from "@/components/app/GoogleSignInButton";
import SEO from "@/components/app/SEO";

export default function LoginPage() {
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Connexion réussie");
      const redirect = sp.get("redirect");
      if (redirect) nav(redirect);
      else if (u.role === "admin") nav("/admin");
      else if (u.role === "broker") nav("/courtier");
      else nav("/espace");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Identifiants invalides");
    } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <SEO title="Connexion" description="Connectez-vous à votre espace Résiliation Express." canonical="/connexion" noindex />
      <div className="card-elevated p-8">
        <h1 className="text-2xl font-bold tracking-tight mb-2">Connexion</h1>
        <p className="text-sm text-muted-foreground mb-6">Accédez à votre espace pour suivre vos dossiers.</p>

        <GoogleSignInButton testid="login-google-btn" />
        <div className="my-5 flex items-center gap-3 text-xs uppercase tracking-wide text-muted-foreground">
          <div className="h-px flex-1 bg-border" />
          <span>ou</span>
          <div className="h-px flex-1 bg-border" />
        </div>

        <form onSubmit={submit} className="space-y-4" data-testid="login-form">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
          </div>
          <div>
            <Label htmlFor="password">Mot de passe</Label>
            <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-gradient-brand text-white border-0 hover:opacity-90" data-testid="login-submit-btn">
            {loading ? "Connexion..." : "Se connecter"}
          </Button>
        </form>
        <p className="text-sm text-muted-foreground mt-6 text-center">
          <Link to="/mot-de-passe-oublie" className="text-primary hover:underline" data-testid="forgot-password-link">Mot de passe oublié&nbsp;?</Link>
        </p>
        <p className="text-sm text-muted-foreground mt-4 text-center">
          Pas encore de compte ? <Link to="/inscription" className="text-primary font-semibold">Créer un compte</Link>
        </p>
        <div className="mt-6 p-3 rounded-md bg-secondary/60 text-xs text-muted-foreground font-mono">
          Démo : <span className="text-foreground">demo@example.com / Demo2026!</span>
        </div>
      </div>
    </div>
  );
}
